<div class="modal fade show" role="dialog" tabindex="-1" style="display: block;">
    <div class="modal-dialog" role="document" style="min-width: 96%;">
        <div class="modal-content">
            <div class="fullscreen" #card #fullscreen="ngxFullscreen" ngxFullscreen>
                <div>
                    <div class="modal-header theme_background">
                        <h5 class="modal-title">
                            <div>
                                <div class="d-flex justify-content-start table_title" style="width: 200px !important;">MNO's List</div>
                            </div>
                        </h5>
                        <div class="d-flex justify-content-end" style="width:93% !important;position: relative;">
                            <!-- Added Button Before Search Bar -->
                            <button class="btn btn-primary"  style="margin-right: 10px;"  (click)="OpenMNOAddPopup(newMnoModel)">
                               Add MNO <i class="fa fa-plus"
                               aria-hidden="true"></i>
                            </button>
                        
                            <input type="search" id="filter-text-box" maxlength="200" placeholder="Search ..."
                                (input)="onFilterTextBoxChanged()" [(ngModel)]="searchValue" 
                                class="input-srch color_theme">
                            <span style="position: absolute; right: 5.5%; top: 5px; color: grey;" *ngIf="!searchValue">
                                <i class="fa fa-search"></i>
                            </span>
                            <span style="position: absolute; right: 5.5%; top: 5px; color: grey;" *ngIf="searchValue"
                                (click)="clearSearch()"> <i class="fa fa-times"></i>
                            </span>
                            <div style="margin-bottom: -25px;">
                                <div class="nav-item full-screen fullscreen-button">
                                    <a id="button-fullscreen" name="button-fullscreen" class="new nav-link full-screen-link custom_iconlink"
                                        href="javascript:;">
                                        <i class="fe fe-maximize" *ngIf="!screenHide" (click)="openFullscreen()"></i>
                                        <i _ngcontent-iqg-c37="" *ngIf="screenHide" class="fe fe-minimize" (click)="closeFullscreen()"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        <button style="background-color: transparent; border: none;color: #9295a4;"
                            (click)="closePopup()"><i class="fa fa-times" aria-hidden="true"></i></button>
                    </div>
                </div>
                <div class="modal-body theme_background">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card mb-0">
                                <div>
                                    <ag-grid-angular style="width: 100%; height: 60vh;"
                                        class="ag-theme-alpine-dark vertical-middle" [columnDefs]="columnDefs" [context]="context"
                                        [rowData]="rowData" [pagination]="true" [defaultColDef]="defaultColDef"
                                        [paginationPageSize]="20" [cacheQuickFilter]="true"
                                         [rowSelection]="rowSelection"
                                        (gridReady)="onGridReady($event)"
                                        (selectionChanged)="onSelectionChanged($event)"></ag-grid-angular>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer"><button type="button" class="btn btn-primary" style="margin-right: 20px;"
                        (click)="closePopup()">Close</button></div>
            </div>
        </div>
    </div>
</div>

<ng-template #newMnoModel let-modal>
    <div class="modal-header">
        <h4>{{ isEditMode ? 'Edit MNO' : 'Add New MNO' }}</h4>

    </div>
    <div class="modal-body " >        
        <form (ngSubmit)="createNewMno()" #mnoForm="ngForm">
            <div style="height: 70vh; overflow-y: auto;">
                <div class="mb-1">
                    <label for="region" class="text-muted mb-0"><strong>Region</strong>
                        <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                    <input type="text" #regionInput class="form-control" id="region" [(ngModel)]="newMno.region" [disabled]="isEditMode" name="region" required placeholder="Enter Region" (ngModelChange)="newRegionChange($event)" />
                  
                    <ul *ngIf="filteredRegions.length > 0 && newMno.region && !isEditMode" class="autocomplete-list theme_background color_theme ">
                        <li
                              *ngFor="let country of filteredRegions"
                              (click)="selectCountry(country)"
                              class="autocomplete-item"
                        >
                              {{ country }}
                        </li>
                        </ul>
                    <div *ngIf="mnoForm.controls.region?.invalid && (mnoForm.controls.region?.touched || mnoForm.submitted)" class="text-danger">
                        Region is required.
                    </div>
                </div>
            <div class="mb-1">
                <label for="mno" class="text-muted mb-0"><strong>MNO</strong>
                    <span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <input type="text" class="form-control" id="mno" [(ngModel)]="newMno.mno" name="mno" required placeholder="Enter Mno" (ngModelChange)="newMnoChange()" />
                <div *ngIf="mnoForm.controls.mno?.invalid && (mnoForm.controls.mno?.touched || mnoForm.submitted)" class="text-danger">
                    MNO is required.
                </div>
                <div *ngIf="uniqueError">
                <p class="text-danger" >{{uniqueError}}</p>
            </div>
            </div>
            <div class="mb-1">
                <label class="text-muted mb-0">MCC:<span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListMcc>
                        <mat-chip *ngFor="let code of newMno.mcc" [selectable]="true" [removable]="true" (removed)="removeCode('mcc', code)">
                            {{ code }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                            id="mcc"
                            name="mcc"
                            [(ngModel)]="mccInput"
                            #mcc="ngModel"
                            placeholder="Add MCC codes (numbers only)..."
                            [matChipInputFor]="chipListMcc"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addCode('mcc', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                            (paste)="handlePaste('mcc', $event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
                <div *ngIf="(mcc.touched || mnoForm.submitted) && !newMno.mcc.length" class="text-danger">
                    MCC is required and must contain at least one valid number.
                </div>
            </div>
            
            <div class="mb-1">
                <label class="text-muted mb-0">MNC:<span class="ms-2" style="color: red; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListMnc>
                        <mat-chip *ngFor="let code of newMno.mnc" [selectable]="true" [removable]="true" (removed)="removeCode('mnc', code)">
                            {{ code }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input
                            id="mnc"
                            name="mnc"
                            [(ngModel)]="mncInput"
                            #mnc="ngModel"
                            placeholder="Add MNC codes (numbers only)..."
                            [matChipInputFor]="chipListMnc"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addCode('mnc', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                            (paste)="handlePaste('mnc', $event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
                <div *ngIf="(mnc.touched || mnoForm.submitted) && !newMno.mnc.length" class="text-danger">
                    MNC is required and must contain at least one valid number.
                </div>
            </div>
            
            <!-- Dynamic 4G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">4G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                   
                    <mat-chip-list #chipList4G>
                      
                        <mat-chip *ngFor="let band of newMno.bands4G" [selectable]="true" [removable]="true" (removed)="removeBand('4G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add 4G bands (numbers only)..."
                            [matChipInputFor]="chipList4G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('4G', $event)"
                            (paste)="pasteBands('4G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Dynamic 5G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">5G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipList5G>
                        <mat-chip *ngFor="let band of newMno.bands5G" [selectable]="true" [removable]="true" (removed)="removeBand('5G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add 5G bands (numbers only)..."
                            [matChipInputFor]="chipList5G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('5G', $event)"
                            (paste)="pasteBands('5G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Dynamic NSA 5G Bands -->
            <div class="mb-1">
                <label class="text-muted mb-0">NSA 5G Bands:<span class="ms-2" style="color: orange; font-size: 20px;">*</span></label>
                <mat-form-field class="band-chip-list" appearance="fill">
                    <mat-chip-list #chipListNsa5G>
                        <mat-chip *ngFor="let band of newMno.bandsNsa5G" [selectable]="true" [removable]="true" (removed)="removeBand('Nsa5G', band)">
                            {{ band }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                        <input 
                            placeholder="Add NSA 5G bands (numbers only)..."
                            [matChipInputFor]="chipListNsa5G"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="true"
                            (matChipInputTokenEnd)="addBand('Nsa5G', $event)"
                            (paste)="pasteBands('Nsa5G', $event)"
                            matInput
                            (keypress)="allowOnlyNumbers($event)"
                        />
                    </mat-chip-list>
                </mat-form-field>
            </div>
            <!-- Submit and Close buttons -->
           
            </div>
            <hr>
            <p class="text-center text-warning" >{{errormessage}}</p>

            <div class="popup-actions">
                <button type="submit"class="btn btn-primary width75" [disabled]="mnoForm.invalid || enableSaveButton"> {{ isEditMode ? 'Update' : 'Save' }}</button>
                <button type="button" class="btn btn-danger width75" (click)="closeModal()" >Cancel</button>
            </div>
        </form>
    </div>

</ng-template>